import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IBranch } from '../interfaces';

export type IGetAzerpostBranchesRepoResponse = IRepoResponse<200, { data: IBranch[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetAzerpostBranchesRepo = IRepo<[any], IGetAzerpostBranchesRepoResponse>;

export const GetAzerpostBranchesRepoType = Symbol.for('GetAzerpostBranchesListRepo');

@bind(GetAzerpostBranchesRepoType)
export class GetAzerpostBranchesRepo implements IGetAzerpostBranchesRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/azerpost/branches', query) });

      if (result.status === 200) {
        const data: IBranch[] = result.data.data;
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
